import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Alignment } from '../types/Alignment';

export function composeAlignmentClasses(alignment: Adaptive<Alignment>): string {
    if (typeof alignment === 'object') {
        return clsx(
            alignment.base && 'alignment.base',
            alignment.sm && `sm:items-${alignment.sm}`,
            alignment.md && `md:items-${alignment.md}`,
            alignment.lg && `lg:items-${alignment.lg}`,
            alignment.xl && `xl:items-${alignment.xl}`,
            alignment['2xl'] && `2xl:items-${alignment['2xl']}`
        );
    }

    return `items-${alignment}`;
}
